/** Shared empty readonly array — useful as a defensive default for prop fallbacks. */
export const EMPTY_SLUGS: ReadonlyArray<string> = []
